import { ElementViewTemplate, html, slotted } from "@microsoft/fast-element";
import { NatGenRadio } from "./radio";
import { RadioOptions } from "./radio.options";
import { staticallyCompose } from "../../foundation/template-helpers";
import { whitespaceFilter } from "../../utilities/whitespace-elements-filter";

export function radioTemplate<T extends NatGenRadio>(
    options: RadioOptions = {}
): ElementViewTemplate<T> {
    return html<T>`
        <template
            role="radio"
            aria-checked="${x => x.checked}"
            aria-required="${x => x.required}"
            aria-disabled="${x => x.disabled}"
            @keypress="${(x, c) => x.keypressHandler(c.event as KeyboardEvent)}"
            @click="${(x, c) => x.clickHandler(c.event as MouseEvent)}"
        >
            <div part="control" class="control">
                <slot name="checked-indicator">
                    ${staticallyCompose(options.checkedIndicator)}
                </slot>
            </div>
            <label
                part="label"
                class="${x =>
                    ["label", !x.defaultSlottedNodes?.length && "label__hidden"]
                        .filter(Boolean)
                        .join(" ")}"
            >
                <slot
                    ${slotted({
                        property: "defaultSlottedNodes",
                        filter: whitespaceFilter,
                    })}
                ></slot>
            </label>
        </template>
    `;
}
